import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';

interface StartMfaCustomerData {
  firstName: string;
  lastName: string;
  onboardingStatus: string;
  passwordSet: boolean;
  profile: string;
  bank: string;
  country?: string;
}

export interface StartMfaResponse {
  customerId: string;
  mfaDestination: string;
  mfaType: string;
  additionalBusiness: boolean;
  customerData: StartMfaCustomerData;
}

export interface StartMfaPhoneVerificationParams {
  customerId: string;
}

export const startMfaPhoneVerification = async (params: StartMfaPhoneVerificationParams) => {
  const { customerId } = params;

  const url = `v3/onboarding/secondary/${customerId}/start`;

  const response = await HttpService.post<StartMfaResponse>(url, {
    customerId,
  });

  return response.data;
};

export interface UseStartMfaPhoneVerificationParams {
  customerId: string;
  onSuccess?: (data: StartMfaResponse) => void;
}

export const useStartMfaPhoneVerification = (params: UseStartMfaPhoneVerificationParams) => {
  const { customerId, onSuccess } = params;

  return useMutation({
    mutationFn: () => startMfaPhoneVerification({ customerId }),
    onSuccess,
  });
};
